// src/App.js
import React from 'react';
import useMeta from '../../hooks/useMeta';

import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

//Page Component
import WhyPageSection from './PageComponent/WhyPageSection';


function WhyCallistus() {
  useMeta({
    title: 'Why Callistus | Callistus Blinds',
    description: 'Discover premium window treatments at Callistus Blinds. Explore our extensive range of stylish blinds and shades to enhance your home’s aesthetic and comfort.',
    canonical: 'https://callistusblinds.com/why-callistus/',
    og: {
      locale: 'en_US',
      type: 'article',
      title: 'Why Callistus | Callistus Blinds',
      description:
        'Callistus is a multinational brand which is supported by entrepreneurs with vast experience in various countries for more than 25 years in the Window Covering Industry. Being the most Innovative, Quality Oriented and determined to give unparalleled service is our Motto. We have the largest range of Blinds in the world which are corresponded with the highest options of excellent Operating Systems. Enhancing your window furnishing with a huge array of complementing fabrics is our priority.',
      url: 'https://callistusblinds.com/why-callistus/',
      site_name: 'Callistus Blinds',
    },
  });

  return (
    <div>
      <Navbar />
      <NotificationBar />
      <WhyPageSection />
      <Footer />
    </div>
  );
}

export default WhyCallistus;
